document.addEventListener("DOMContentLoaded", function () {
    const menuButton = document.querySelector(".header__icon--menu");
    const menuDrawer = document.querySelector("header-drawer");

    if (menuButton && menuDrawer) {
        menuButton.addEventListener("click", function () {
            menuDrawer.classList.toggle("open");
        });
    } else {
        console.warn("Menu button or drawer not found.");
    }
});
